import React, { Component } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import withFetchHook from "../withFetchHook";

class TransactionFormModal extends Component {
  state = {
    loading: false
  }

  constructor(props) {
    super(props);
    this.signatureCanvas = React.createRef()
  }

  componentDidUpdate() {
    if (!this.signaturePad && this.signatureCanvas.current) {
      this.signaturePad = new SignaturePad(this.signatureCanvas.current, {
        onEnd: this.handleSignatureUpdate.bind(this)
      });
    }

    if (!this.props.show) {
      this.signaturePad = null;
    }
  }

  handleSignatureUpdate() {
    this.handleChange("resident_signature", this.signaturePad.toDataURL());
  }

  handleClose() {
    this.props.closeModal();
  }

  handleChange(name, value) {
    this.props.updateField(name, value);
  }

  createTransaction() {
    const { organizationName, residentId, userId, updateTransactions } = this.props;
    const { description, amount, resident_signature } = this.props.transaction;

    this.setState({ loading: true });

    this.props.fetch(`/organizations/${organizationName}/transactions.json`, {
      method: "POST",
      data: {
        transaction: {
          user_id: userId,
          resident_id: residentId,
          description,
          amount,
          resident_signature
        }
      }
    }).then(() => {
      this.getTransactions();
    })
  }

  getTransactions() {
    const { organizationName, residentId } = this.props;
    this.props.fetch(`/organizations/${organizationName}/transactions.json`, {
      data: {
        by_resident: residentId
      }
    }).then((data) => {
      this.props.updateTransactions(data);
      this.props.closeModal();
      this.setState({ loading: false });
    })
  }

  render() {
    const {
      description,
      amount,
    } = this.props.transaction;

    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Transaction</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="transactionDescription">
            <Form.Label>Description</Form.Label>
            <Form.Control
              value={description}
              onChange={(e) => {
                this.handleChange('description', e.target.value)
              }} />
          </Form.Group>
          <Form.Group controlId="transactionDescription">
            <Form.Label>Amount</Form.Label>
            <Form.Control
              value={amount}
              type="number"
              onChange={(e) => {
                this.handleChange('amount', e.target.value)
              }} />
          </Form.Group>
          <Form.Group controlId="transactionSignature">
            <Form.Label>Signature</Form.Label>
            <div>
              <canvas
                ref={this.signatureCanvas}
                style={{ border: "1px solid #CCC" }} />
            </div>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={this.state.loading}
            variant="info"
            onClick={() => this.createTransaction()}>
            Create Transaction
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.transactionModal.show,
    transaction: state.ui.transactionModal.transaction,
    action: state.ui.transactionModal.action,
    organizationName: state.organization.name,
    residentId: state.resident.id,
    userId: state.current_user.id
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => {
      dispatch({
        type: "CLOSE_RESOURCE_MODAL",
        payload: { resourceName: "transaction" }
      });
    },
    updateField: (name, value) => {
      dispatch({
        type: "UPDATE_RESOURCE_FIELD",
        payload: { resourceName: "transaction", name, value }
      });
    },
    createTransaction: (transaction) => {
      dispatch({
        type: "CREATE_TRANSACTION",
        payload: { transaction }
      });
    },
    updateTransactions: (transactions) => {
      dispatch({
        type: "UPDATE_TRANSACTIONS",
        payload: { transactions }
      });
    }
  };
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(TransactionFormModal));
